import List from './List';

export const AppConfig = {
  List,
};
